import React from 'react';
import {Button} from 'react-bootstrap';
import {Icon} from '../../components';

/**
 * Bulk Actions Toolbar
 * Shows when items are selected, allows bulk operations
 */
export default class BulkActionsToolbar extends React.Component {
  render() {
    const {selectedCount, onBulkSkip, onClearSelection} = this.props;

    if (selectedCount === 0) {
      return null;
    }

    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <strong style={{fontSize: '14px', whiteSpace: 'nowrap'}}>
          {selectedCount} alert{selectedCount > 1 ? 's' : ''} selected
        </strong>
        <Button
          bsStyle="primary"
          bsSize="small"
          onClick={onBulkSkip}>
          <Icon fa="forward" /> Skip Selected
        </Button>
        <Button
          bsStyle="default"
          bsSize="small"
          onClick={onClearSelection}>
          Clear Selection
        </Button>
      </div>
    );
  }
}

BulkActionsToolbar.propTypes = {
  selectedCount: React.PropTypes.number.isRequired,
  onBulkSkip: React.PropTypes.func.isRequired,
  onClearSelection: React.PropTypes.func.isRequired
};
